module.exports = __webpack_public_path__ + "img/logo.47f8fe49.svg";